import {Message} from "semantic-ui-react";

export default function InviteWarning(props: {warning: string}){

    return(
        <Message negative>
         {props.warning}
        </Message>
    )
}